import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  TextField,
  Card,
  CardContent,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import BpIcon from "../../assets/bpIcon.png";
import PaidIcon from "../../assets/paidicon.png";
import Refundicon from "../../assets/refund.png";
import RechargeSuccessImg from "../../assets/rechargeSuccess.png";
import changeArrow from "../../assets/changeArrow.png";
import WaitingLoder from "../../Loader/component";
import DpHistoryHeader from "./BpHistoryHeader";
import { Padding } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import UnlinkWalletModal from "./popup";
import BpHistoryHeader from "./BpHistoryHeader";

const amounts = [50, 100, 200, 500];

const TruncatedOrderId = ({ text, limit }) =>
  text && text.length <= limit ? text : `${text?.substring(0, limit)}...`;

// --------------------- RECHARGE MODAL ---------------------
const RechargeModal = ({ open, onClose, amount, setAmount, AddIntoCart }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate=useNavigate()

  const handleRoute=()=>{
    navigate(`/paymentOptions?route=dphistory`)
  }

  const paymentMethod =
    localStorage.getItem("default_Recharge_PgName") === "RECHARGE_R_CARD"
      ? "CARD"
      : localStorage.getItem("default_Recharge_PgName") === "RECHARGE_R_WALLET"
      ? "WALLET"
      : "UPI";

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: isMobile ? "flex-end" : "center",
        backdropFilter: "blur(3px)",
      }}
    >
      <Box
        sx={{
          width: isMobile ? "100%" : 360,
          bgcolor: "background.paper",
          borderRadius: isMobile ? "20px 20px 0 0" : 2,
          p: 3,
          boxShadow: 24,
          outline: "none",
          transition: "transform 0.3s ease-in-out",
        }}
      >
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Select an amount to
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Recharge Daalchini Points
        </Typography>

<TextField
  fullWidth
  placeholder="Enter Amount"
  value={amount}
  onChange={(e) => {
    const value = e.target.value;

    // allow empty
    if (value === "") {
      setAmount("");
      return;
    }

    // allow only digits
    if (/^\d+$/.test(value)) {
      setAmount(value);
    }
  }}
  inputProps={{
    maxLength: 5,
    inputMode: "numeric",
    pattern: "[0-9]*",
  }}
  sx={{ my: 2 }}
/>


        <Stack direction="row" spacing={1} mb={2}>
          {amounts.map((amt) => (
            <Button
           
          
              key={amt}
              variant={amount === amt ? "contained" : "outlined"}
              onClick={() => setAmount(amt)}
              sx={{
                 color:"#00B177",
                flex: 1,
                fontWeight: 600,
                ...(amount === amt && {
                  backgroundColor: "#00B177",
                  color: "white",
                  "&:hover": { backgroundColor: "#00925E" },
                }),
              }}
            >
              ₹{amt}
            </Button>
          ))}
        </Stack>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box>
            <Typography variant="subtitle2">Payment Method</Typography>
            <Typography variant="body2">{paymentMethod}</Typography>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            sx={{ cursor: "pointer" }}
            onClick={(e) => (handleRoute(e))}
          >
            <Typography variant="caption" color="text.secondary" mr={0.5}>
              Change
            </Typography>
            <img src={changeArrow} alt="change"  style={{width:"7px" ,height:"10px"}} />
          </Box>
        </Box>

        <Button
          variant="contained"
          fullWidth
          onClick={AddIntoCart}
          sx={{
            backgroundColor: "#00B177",
            fontWeight: 700,
            py: 1.2,
            borderRadius: "10px",
            "&:hover": { backgroundColor: "#00925E" },
          }}
        >
          Proceed To Pay
        </Button>
      </Box>
    </Modal>
  );
};

// --------------------- SUCCESS MODAL ---------------------
const SuccessModal = ({ open, onClose, amount }) => (
  <Modal
    open={open}
    onClose={onClose}
    sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    <Box
      sx={{
        width: 300,
        bgcolor: "background.paper",
        borderRadius: 2,
        p: 3,
        textAlign: "center",
        outline: "none",
      }}
    >
      <div style={{display:"flex",alignContent:"center",justifyContent:"center"}}>
      <img src={RechargeSuccessImg} alt="success" width={72} />
      </div>
      <Typography variant="h6" mt={2}>
        Success
      </Typography>
      <Typography variant="body2" mt={1}>
        Wallet has been successfully recharged with ₹{amount}
      </Typography>
      <Button
        variant="contained"
        onClick={onClose}
        sx={{ mt: 3, backgroundColor: "#00B177" }}
      >
        OK
      </Button>
    </Box>
  </Modal>
);

// --------------------- TRANSACTION CARD ---------------------
const TransactionCard = ({ transaction }) => {
  //console.log("transaction---",)
  const isDebit = transaction.opsType === "debit";
  const amountColor = isDebit
    ? "#F43F5E"
    : transaction.transactionType === "money_add"
    ? "#00B177"
    : "#583C43";

  return (
    <Card
      sx={{
        mb: 2,
        borderRadius: 2,
        boxShadow: "0px 4px 10px rgba(56, 79, 111, 0.12)",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <img src={isDebit ? PaidIcon : Refundicon} alt="icon" width={44} />
          <Box>
            <Typography variant="subtitle2" color="text.primary">
              {isDebit
                ? "Paid amount"
                : transaction.transactionType === "money_add"
                ? "Balance added"
                : "Refunded amount"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ID: <TruncatedOrderId text={transaction.orderId} limit={20} />
            </Typography>
          </Box>
        </Stack>
        <Box textAlign="right">
          <Typography variant="subtitle2" sx={{ color: amountColor }}>
            ₹{transaction.amount}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {transaction.timestamp.slice(0, 10)}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

// --------------------- MAIN COMPONENT ---------------------
const BpHistoryComp = ({
  loader,
  bpHistory,
  paymentOptionsList,
  rechargeModal,
  setRechargeModal,
  amount,
  setAmount,
  AddIntoCart,
  RechargeFun,
  rechargeSuccessModal,
  setRechargeSuccessModal,
  clearPreCart,
  unlinkModal,
  setUnlinkModal,
  BpUnlink,
  requestsumbitted,
  setRequestsumbitted
}) => {
  const [indianTime, setIndianTime] = useState("");
//console.log("BpHistoryComp",bpHistory)
  useEffect(() => {
    const now = new Date();
    const options = { timeZone: "Asia/Kolkata", hour12: true };
    setIndianTime(now.toLocaleString("en-IN", options));
  }, []);

  const bpbalance = paymentOptionsList?.[2]?.balance?.toFixed(2) || 0;
const handleUnlink=(e)=>{
  BpUnlink()
}
  return (
    <>
    <UnlinkWalletModal
    unlinkModal={unlinkModal}
    setUnlinkModal={setUnlinkModal}
    BpUnlink={BpUnlink}
    requestsumbitted={requestsumbitted}
    setRequestsumbitted={setRequestsumbitted}

/>
      <BpHistoryHeader title={"Business Payments"} route={"/paymentOptions"}/>
      {loader && <WaitingLoder />}

      <Box
        sx={{
          position: "relative",
          fontFamily: "Roboto",
        
          overflow: "hidden",
          mt: "68px",
        }}
      >
        {/* Fixed DP Card */}
        <div style={{padding:"5%"}}>
        <Card
        style={{marginRight:"10px",marginLeft:"10px",height:"163px",borderRadius:"15px"}}
          sx={{
           
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
        

            position: "fixed",
            top: "68px",
            left: 0,
            right: 0,
            zIndex: 10,
            borderRadius: 0,
            boxShadow: "0px 4px 10px rgba(56,79,111,0.15)",
            backgroundColor: "#fff",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <img src={BpIcon} alt="BP Icon" width={57} />
            <Box>
              <Typography variant="h6">Business Payments</Typography>
              <Typography variant="body2">{indianTime}</Typography>
            </Box>
          </Stack>

          <Box textAlign="right" style={{display: "flex", justifyContent:"space-between",    alignItems:"center",
    padding: "20px",        paddingLeft: "0",
    paddingRight: "0",}}>
            <Box >
            <Typography variant="body2" color="text.secondary">
              Balance amount
            </Typography>
          
            <Typography variant="h6"     textAlign={"left"}>₹{bpbalance}</Typography>
            </Box>
              <Box>
            <Button
              variant="contained"
              onClick={(e)=>{handleUnlink(e)}}
              sx={{ mt: 1, backgroundColor: "#00B177",borderRadius:"25px" }}
            >
              Unlink
            </Button>
            </Box>
          </Box>
        </Card>
        </div>

        {/* Scrollable Transactions */}
        <Box
          sx={{
            mt: "150px",
            p: 2,
            overflowY: "auto",
            height: "calc(100vh - 200px)",
          }}
        >
          <Typography variant="h6" mb={2}>
            Transactions History {" "}({bpHistory?.data?.count})
          </Typography>
   {/*   {console.log("transaction+++",bpHistory?.data?.payload)} */}
          {bpHistory?.data?.payload.map((transaction) => (
            <>
           {/*  {console.log("transaction",transaction,bpHistory?.data?.payload)} */}
        {bpHistory?.data?.payload&&bpHistory?.data?.payload[0]&&<TransactionCard key={transaction?.orderId} transaction={transaction} />}
            </>
          ))}
        </Box>
      </Box>


 
    </>
  );
};

export default BpHistoryComp;
